// Direct one-tap stamping by cardId. Reached via /staff/issue/:cardId — a
// deep link used when staff already know the cardId (e.g. from a printed
// receipt or staff-side admin tool). No scanner; just the confirm + result.
//
// Note: this route still requires the customer's stamp_token to satisfy the
// staff stamping endpoint's HMAC verification. Since the customer isn't
// present to scan a QR, this page is intentionally a stub for V1 — it
// surfaces a message explaining staff need to scan via /staff. Kept as a
// route so a future "issue by manual card-code + tenant secret" flow has
// a home; for now it redirects users back to /staff.

import { Link, useParams } from 'react-router-dom'
import './staff.css'

export function StaffIssuePage() {
  const { cardId } = useParams<{ cardId: string }>()

  return (
    <div className="staff-issue">
      <h1>Issue stamp</h1>
      <p className="stamp-hint">
        Direct issuance for card{' '}
        <code className="staff-issue-code">{cardId?.slice(-8).toUpperCase()}</code>{' '}
        needs the customer's pass QR. Ask the customer to open their Naya pass
        and go back to the scanner.
      </p>
      <Link to="/staff" className="owner-btn owner-btn-primary owner-btn-block">
        Back to scanner
      </Link>
    </div>
  )
}
